import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { useTranslation, useNavigate, useErrorPage } from "hooks";
import ErrorMessage from "../error-message";
import Button from "../../button";
import fixing from "./assets/fixing.mp4";

if (process.env.NODE_ENV === "production") {
  Bugsnag.start({
    releaseStage: process.env.STAGE,
    apiKey: process.env.REACT_APP_BUGSNAG_KEY as string,
    plugins: [new BugsnagPluginReact()],
  });
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const EmptyWrapper: (props: ErrorBoundaryProps) => React.ReactNode = ({
  children,
}) => children;

const BugsnagErrorBoundary =
  Bugsnag.getPlugin("react")?.createErrorBoundary(React as any) || EmptyWrapper;

export const ErrorScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useErrorPage();

  return (
    <ErrorMessage
      description={t("errorMessage.serverMessage")}
      alt={t("errorMessage.serverMessage")}
      renderActions={() => (
        <>
          <Button
            onClick={() => window.location.replace(window.location.origin)}
            title={t("errorMessage.goToHome")}
          >
            {t("errorMessage.goToHome")}
          </Button>
          <Button
            onClick={() => {
              navigate(-1);
              setTimeout(() => window.location.reload(), 1000);
            }}
            variant="clear"
            title={t("errorMessage.previousPage")}
          >
            {t("errorMessage.previousPage")}
          </Button>
        </>
      )}
      /* eslint-disable-next-line jsx-a11y/media-has-caption */
      asset={<video autoPlay loop muted src={fixing} />}
    />
  );
};

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => (
  // eslint-disable-next-line
  // @ts-ignore
  <BugsnagErrorBoundary FallbackComponent={ErrorScreen}>
    {children}
  </BugsnagErrorBoundary>
);

export default ErrorBoundary;
